module.exports = __webpack_public_path__ + "img/8a70795e0f7bd527816e84c4c5996337.png";